var timeout, navOffset;
var ES = (function($) {

	var init = function() {

		$('.fitText:not(.desktopOnly)').fitText(1.7);

		$('.no-touch .expanded a.logo').hover(function() {
			$('img.glow').toggleClass('active');
		});

		// Open Search Modal
		$('.openSearch').click(function() {

			$('.searchModal').addClass('show');
			$('html').addClass('modalOpen');

		});

		// Close Modal
		$('.modal .close').click(function() {
			$('.modal').removeClass('show');
			$('html').removeClass('modalOpen');
			$('html').removeClass('mobileNavOpen');
		});

		// Mobile Nav interaction
		$('.hamburger').click(function() {

			$('.mobileNav').toggleClass('show');
			$('html').toggleClass('mobileNavOpen');

		});

		// Image gallery thumbnails
		$('.images .thumbs img').click(function() {

			$('.images .thumbs li').removeClass('active');

			$(this).closest('li').addClass('active');

			var newImage = $(this).data('full');
			$('.images figure img').attr('src', newImage);

		});

	};
	
	var scroll = function() {

		var pixelsScrolled = $(window).scrollTop();

		$('.expanded nav.main').css('margin-top', -pixelsScrolled/2 + 'px');

		if( pixelsScrolled > 30 ) {
			$('body').removeClass('expanded');
		} else {
			$('body').addClass('expanded');
		}
	
	};

	var resize = function() {

		var winW = $(window).width();

		// Adjustin input text
		if( winW < 900 ) {
			var placeholder = $('.searchModal input').attr('data-shortPlaceholder');
			$('.searchModal input').attr('placeholder', placeholder);
		} else {
			var placeholder = $('.searchModal input').attr('data-longPlaceholder');
			$('.searchModal input').attr('placeholder', placeholder);			
		}

		if( winW < 768 ) {
			$('body').addClass('collapsed');
		} else {
			$('body').removeClass('collapsed');		
  			$('.mobileNav').removeClass('show');
			$('html').removeClass('mobileNavOpen');

		}
      
      
		// Match the heights of all products in grid  
    	var maxHeight = 0;
	    
      	$('.products li').attr('style', ''); // Clear the heights before sizing takes place
      	
      	$('.products li').each(function() { 
          	
        	maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
          
          	$('.products li').height(maxHeight);
          
        });
      
      	// Match the heights of the L and R columns on the home page
      	var colLHeight = 0;
	      $('section.big .colR').css({

	            'overflow' : 'hidden',
            	'height' : 	$('section.big .colL').height()
            
			});
      

	};

	var keys = function(e) {

		// ESCAPE KEY
		if (e.keyCode == 27) {
			$('.modal .close').trigger('click');
		}

	}

	return {
		init: 	init,
		scroll: scroll,
		resize: resize,
		keys: 	keys
	};

}(jQuery));

$(document).ready(function() {
	ES.init();
	ES.scroll();
});

$(window).load(function() {
	ES.resize();
});

$(window).scroll(function() {
	ES.scroll();
});

$(window).resize(function() {
	ES.resize();
});

$(document).keyup(function(e) {
	ES.keys(e);
});
